import { defineMessages, useIntl } from 'react-intl';

import ReportIcon from '@/material-icons/400-24px/report.svg?react';
import { ColumnLink } from 'mastodon/features/ui/components/column_link';

const messages = defineMessages({
  reportBug: {
    id: 'navigation_bar.report_bug',
    defaultMessage: 'Report a bug',
  },
});

/**
 * Shortcut to /report-bug, sitting directly under "More" in the side menu.
 *
 * Deliberately a visible entry rather than another row inside the More
 * dropdown: a shortcut you have to open a menu to find is not a shortcut, and
 * people reach for this exactly when something is already going wrong.
 */
export const ReportBugLink: React.FC = () => {
  const intl = useIntl();

  return (
    <ColumnLink
      transparent
      to='/report-bug'
      icon='report'
      iconComponent={ReportIcon}
      text={intl.formatMessage(messages.reportBug)}
    />
  );
};
